/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import { reducerName, createActionName } from './naming';
import * as types from './actionsTypes';
import {
  createValidateObject,
  storeSetFieldValue
} from '../../../../utils/reducerHalpers/formFields';
import * as validateTypes from '../../../../utils/reducerHalpers/validateTypes';

const createCommentFormReducer = name => {
  function stateDefault() {
    return {
      hasInputDisabled: true,
      fields: {
        payout_accounts_type: {
          title: 'Тип счета',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        account_number: {
          title: 'Номер счета',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        bank_key: {
          title: 'Банк',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        },
        memo_tag: {
          title: 'Memo Tag',
          value: '',
          validate: [createValidateObject(validateTypes.REQUIRED)]
        }
      },
      resultObject: {}
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, types.SEND_FORM):
        return state;
      case createActionName(name, types.SET_FIELD_OUTPUT_ACCOUNTS_TYPE): {
        return storeSetFieldValue(
          state,
          'payout_accounts_type',
          action.payload
        );
      }
      case createActionName(name, types.SET_FIELD_ACCOUNT_NUMBER): {
        return storeSetFieldValue(state, 'account_number', action.payload);
      }
      case createActionName(name, types.SET_FIELD_BANK_KEY): {
        return storeSetFieldValue(state, 'bank_key', action.payload);
      }
      case createActionName(name, types.SET_FIELD_MEMO_TAG): {
        return storeSetFieldValue(state, 'memo_tag', action.payload);
      }
      case createActionName(name, types.SET_RESULT_OBJECT):
        return state.merge({
          resultObject: action.payload
        });
      case createActionName(name, types.SET_TRUE_FORM_DISABLED):
        return state.merge({
          hasInputDisabled: true
        });
      case createActionName(name, types.SET_FALSE_FORM_DISABLED):
        return state.merge({
          hasInputDisabled: false
        });
      case createActionName(name, types.INIT_STATE):
        return Immutable(stateDefault());
      default:
        return state;
    }
  };
};

export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createCommentFormReducer(parentName);
  return reduceObject;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccountFrom/reducer.js